import React, { useEffect, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import Loader from '../../Loader/Loader';
import ROUTE_NAVIGATION from '../../../routes/routeQuery';
import PageRenderer from '../../PageRenderer/PageRenderer';
import readConfig from '../../../utils/readClientConfiguration';
import productionConfiguration from '../../../config/default.json';

const ProductQuestionsPopup = ({ productSku, productName, onFormSubmitSuccess }) => {
    const { loading, error, data } = useQuery(ROUTE_NAVIGATION, {
        variables: { url: 'emmezeta-pitanja-o-proizvodu' },
        fetchPolicy: 'cache-first',
    });

    const formConfig = useMemo(() => readConfig(productionConfiguration, 'forms'), []);

    useEffect(() => {
        if (data && data.route && productSku && productName) {
            // Wypełnij pola formularza po załadowaniu
            const fillFormFields = () => {
                const inputSku = document.getElementById(formConfig.inputSkuId || 'field_106');
                const inputName = document.getElementById(formConfig.inputNameId || 'field_112');

                if (inputSku && inputName) {
                    inputSku.value = productSku;
                    inputName.value = productName;
                } else {
                    // Spróbuj ponownie za chwilę, jeśli pola jeszcze nie istnieją
                    setTimeout(fillFormFields, 100);
                }
            };

            fillFormFields();
        }
    }, [data, productSku, productName, formConfig]);

    // Nasłuchuj na sukces wysłania formularza
    useEffect(() => {
        const handleFormSuccess = () => {
            if (onFormSubmitSuccess) {
                // Opóźnij zamknięcie, aby użytkownik zobaczył komunikat o sukcesie
                setTimeout(() => {
                    onFormSubmitSuccess();
                }, 2000);
            }
        };

        // Nasłuchuj na zdarzenie z formBuilderAjax
        window.addEventListener('formSubmitSuccess', handleFormSuccess);

        return () => {
            window.removeEventListener('formSubmitSuccess', handleFormSuccess);
        };
    }, [onFormSubmitSuccess]);

    if (loading) return <Loader />;
    if (error) {
        console.error('Error loading form:', error);
        return <p>Greška pri učitavanju obrasca: {error.message}</p>;
    }
    if (!data || !data.route) {
        return <p>Obrazac nije pronađen.</p>;
    }

    return (
        <div className="product-questions-popup">
            <PageRenderer routeData={data.route} />
        </div>
    );
};

export default ProductQuestionsPopup;
